import { defineStore } from 'pinia'

import SharedSettingsRepository from '@/common/repositories/shared-settings-repository'

type AvailableSettings = 'contact-mail'
    | 'contact-street'
    | 'contact-city'
    | 'contact-postal-code'
    | 'contact-phone'
    | 'contact-geo-latitude'
    | 'contact-geo-longitude'
    | 'social-facebook'
    | 'social-youtube'
    | 'social-instagram'
    | 'social-linkedin'
    | 'social-mixcloud'
    | 'social-tiktok'
    | 'player-history'
    | 'player-android'
    | 'discord-bot-invite-url'
    | 'cm-cm'
    | 'cm-ksaf'
    | 'cm-mine'
    | 'cm-bis'
    | 'home-ads-count'
    | 'stream-address'
    | 'maintenance-mode'
    | 'last-audio-cleanup'
    | 'last-image-cleanup'
    | 'price-list-show-prices'
    | 'disable-chat'
    | 'hot17-enabled'
    | 'hot17-start-day'
    | 'hot17-end-day'
    | 'hot17-end-hour'
    | 'equipment-rental-buffer'

const useSharedSettingsStore = defineStore('sharedSettings', {
    state: () => ({
        loaded: false,
        settings: {} as Record<string, string>
    }),
    actions: {
        async load (): Promise<void> {
            this.settings = await SharedSettingsRepository.all()
            this.loaded = true
        }
    },
    getters: {
        setting: (state) => {
            return (key: AvailableSettings): string => {
                if (key in state.settings) {
                    return state.settings[key]
                }

                if (state.loaded) {
                    console.warn(`Setting ${key} not found`)
                }

                return ''
            }
        }
    }
})

export {
    useSharedSettingsStore,
    type AvailableSettings
}
